export default __webpack_public_path__ + "static/play-rule-pc-2f867d84dd8a117987887dc1f9438b98.png";